/* eslint-disable radix */

export function addModuloID(idModulo) {
  return {
    type: 'ADD_MODULO_MENU_ID',
    idModulo,
  };
}

export function addMenuID(idMenu) {
  return {
    type: 'ADD_MENU_ID',
    idMenu,
  };
}
